import React, { useState } from 'react';
import { SelectDD, ExternalDD } from '../../common/dropdowns';
import { relocateType } from '../../appConstants';
import { visaType } from '../../appConstants';

function FilterAspirants(props) {
    
    return (
         <div className="card"  >
                        <div className="card-header">
                            <div className="card-header-left">
                                <h5>Filters</h5>
                            </div>
                            <div className="card-header-right">
                                <button className="btn btn-primary">Clear All</button>                    
                            </div>
                        </div>
                        <div className="card-block">
                            <div>Expertise Category</div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Web & Software Development</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Data Science & Analytics</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Sales & Marketing</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Graphics & Design</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Accounting & Audits</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Digital Marketing</span>
                                </label>
                            </div>
                            <div >+5 More</div>


                            <div>Skills</div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Reactjs</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >HTML</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Python</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >SAS</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Java</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Sql</span>
                                </label>
                            </div>
                            <div >+34 More</div>
                            <div >Advanced Filter</div>
                            <div >Scores</div>
                            <div >Difficulty Level</div>



                            <div>Yrs. of Experience</div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Fresher</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >0 - 2</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >2 - 5</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >5 - 8</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >8 - 12</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >>12</span>
                                </label>
                            </div>
                            


                            <div>Education</div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Masters</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >BE</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Graduate</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >MTech</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >MBA</span>
                                </label>
                            </div>
                            <div >+6 More</div>
                            <div >Advanced Filter</div>
                            <div >Subject</div>



                            <div>More Options</div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Visa Validity</span>
                                </label>
                            </div>
                            <SelectDD data={visaType} isClearable={false} />
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Available for Work from Home</span>
                                </label>
                            </div>
                            <div className="checkbox-fade fade-in-primary mg-b-10 ">
                                <label>
                                    <input type="checkbox" ></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Ready to Relocate</span>
                                </label>
                            </div>
                            <SelectDD data={relocateType} isClearable={false} />
                        </div>
                    </div>
                
                
     
    
    );
  }

export default FilterAspirants